import React from 'react';

import { mergeClassNameStrings } from '@consumer-frontend/nc-utils';
import {
  Fieldset,
  FieldsetPropsT,
} from '@consumer-frontend/shared-ui';

import '@consumer-bootstrap/netcredit.scss';
// eslint-disable-next-line import/order
import '@consumer-bootstrap/brands/netcredit/form/fieldset.scss';

export type NcFieldsetT = React.FC<FieldsetPropsT>;

export const NcFieldset: NcFieldsetT = ({ className, ...props }) => {
  const classNames = mergeClassNameStrings('nc-fieldset', className);

  return <Fieldset className={classNames} {...props} />;
};
